
URL = globalThis.URL
import __vite__wasmUrl from "/vercel/path0/node_modules/.pnpm/lz4-wasm@0.9.2/node_modules/lz4-wasm/lz4_wasm_bg.wasm?url"
import __vite__initWasm from "/__vite-plugin-wasm-helper"
import * as __vite__wasmImport_0 from "./lz4_wasm_bg.js";
const __vite__wasmModule = await __vite__initWasm({ "./lz4_wasm_bg.js": { "__wbindgen_string_new": __vite__wasmImport_0["__wbindgen_string_new"] } }, __vite__wasmUrl);
export const memory = __vite__wasmModule.memory;
export const compress = __vite__wasmModule.compress;
export const decompress = __vite__wasmModule.decompress;
export const __wbindgen_add_to_stack_pointer = __vite__wasmModule.__wbindgen_add_to_stack_pointer;
export const __wbindgen_malloc = __vite__wasmModule.__wbindgen_malloc;
export const __wbindgen_free = __vite__wasmModule.__wbindgen_free;
